import React from 'react';
import PropTypes from 'prop-types';
import { useDrag } from 'react-dnd';
import './index.scss';

const GenericDndItem = ({ index, itemType, children, className }) => {
  const [{ isDragging }, drag, preview] = useDrag({
    type: itemType,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <div
      ref={preview}
      className={`generic-dnd-item ${className} ${
        isDragging ? 'generic-dnd-item-dragging' : 'generic-dnd-item-normal'
      }`}
    >
      {typeof children === 'function' ? children(drag, isDragging) : children}
    </div>
  );
};

GenericDndItem.propTypes = {
  index: PropTypes.number.isRequired,
  itemType: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  className: PropTypes.string,
};

export default GenericDndItem;
